import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LoanDetailCardWrapper = styled.div`
  align-content: center;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: 912px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    min-height: 320px;
  }
`;

const LoanDetailsTitle = styled.h2`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 16px;
  margin: 0;
  font-size: 20px;
  line-height: 24px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 0 0 24px;
  }
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  margin: 0 0 24px 0;
  border-bottom-color: transparent;
`;

const BridgecrestInformation = styled.div`
  margin-top: 20px;
`;

const LoanPaidOffSuccess = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  border-radius: ${(props) => props.theme.border.radius};
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: ${(props) => props.theme.font.weight.v300};
  ${(props) => props.theme.font.heading.v100};
  justify-content: center;
  ling-height: 24px;
  padding: 16px 0;
  text-align: center;
  margin: 12px 0 0 0;

  & svg {
    margin: 0 0 15px 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    display: flex;
    margin-top: 7px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    & svg {
      margin-bottom: 20px;
    }
  }
`;

const PaidOffMessage = styled.div`
  line-height: 24px;
`;

const PaidOffTitle = styled.h3`
  position: absolute;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.primary.v400};
  align-self: left;
  margin-bottom: 4px;
  ${(props) => props.theme.font.body.v200};
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

const TransactionHistoryLink = styled(Link)`
  bottom: 45px;
  color: ${(props) => props.theme.color.primary.v200};
  ${(props) => props.theme.font.body.v200};
  position: relative;
  margin: 10px 0 0;
  justify-content: center;
  padding-bottom: 8px;
  text-align: center;
  text-decoration: underline;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    bottom: 25px;
    display: flex;
    flex-direction: column;
    line-height: 24px;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.lg}px) {
    bottom: 25px;

    display: flex;
    flex-direction: column;
    line-height: 24px;
  }
`;

const Overview = styled.div`
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 24px;
`;

const PaymentWrapper = styled.div`
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
`;

const TransactionAndBankInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  max-width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: column;
  }
`;

const PaidOffWrapper = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-bottom: 16px;
`;

export {
  LoanDetailCardWrapper,
  LoanDetailsTitle,
  HR,
  LoanPaidOffSuccess,
  SpinnerWrapper,
  TransactionHistoryLink,
  BridgecrestInformation,
  PaidOffMessage,
  Overview,
  PaymentWrapper,
  TransactionAndBankInfoWrapper,
  PaidOffWrapper,
  PaidOffTitle,
};
